export function clearAllCache() {
   caches.keys().then((names) => {
      for (const name of names) {
         caches.delete(name);
      }
   });
}

export function checkBackendVersion(newVersion: string | number) {
   try {
      if (!newVersion) return;

      const version = localStorage.getItem('version_number');
      localStorage.setItem('version_number', newVersion.toString());
      if (version != newVersion) {
         clearAllCache();
      }
   } catch {
      console.info('Failed to auto clear cache');
   }
}
